import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
import { produceLoadLoadingLoadedEpic } from "@ane/core/lib/utils/ReduxObservablesEpicUtils";
import { loadManagedIdentityListActionTypes, loadingManagedIdentityList, loadedManagedIdentityList } from "./ComputeCreateContainer.ducks.js";
import AuthenticationResource from "@ane/exp-data/lib/resources/AuthenticationResources";
const getComputeServiceManagedIdentityEpic = produceLoadLoadingLoadedEpic({
  filterOnType: loadManagedIdentityListActionTypes.LOAD,
  loadResource: (payload) => {
    return AuthenticationResource.getManagedIdentityNameList(payload.workspaceId);
  },
  loadingAction: (payload) => loadingManagedIdentityList(payload.workspaceId),
  loadedAction: (successData, payload, error) => {
    return of(loadedManagedIdentityList(payload.workspaceId, getCompletedAsyncWrapperObj(successData, error)));
  }
});
const ComputeServiceManagedIdentityEpic = combineEpics(getComputeServiceManagedIdentityEpic);
export {
  ComputeServiceManagedIdentityEpic as default,
  getComputeServiceManagedIdentityEpic
};
//# sourceMappingURL=ComputeManagedIdentityEpic.js.map
